import { NoticeItemFactory } from './noticeItemFactory';

import type {
  NoticeItemEntity,
  NoticeItemProps,
} from './noticeItemEntity';
import type { NoticeItemIRepository } from './noticeItemIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { NoticeItemJson } from '@/types/domain/notice/entities/noticeItemEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * 掲示板アイテムのレポジトリ
 */
export class NoticeItemRepository extends AppsyncRepositoryPvt<
  NoticeItemEntity,
  NoticeItemProps,
  NoticeItemJson
> implements NoticeItemIRepository {
  private factory = new NoticeItemFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    return EntityName.WagakoAppNoticeNoticeItemEntity;
  }

  /**
   * データからEntity生成
   * @param props データ
   * @returns Entity
   */
  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
